import { createApi } from "@reduxjs/toolkit/query/react";

import supplierBaseQuery from "./supplierBaseQuery";

export const SUPPLIER_INVITE_API_REDUCER_KEY = "supplierInviteApi";

export const supplierInviteApi = createApi({
  reducerPath: SUPPLIER_INVITE_API_REDUCER_KEY,
  baseQuery: supplierBaseQuery,
  tagTypes: ["supplier-invite"],
  endpoints: (builder) => ({
    getInvitedSuppliers: builder.query({
      query: () => {
        return {
          url: `/users/invites/`,
        };
      },
      providesTags: ["supplier-invite"],
    }),

    inviteSupplier: builder.mutation({
      query: (body) => ({
        url: `/users/invites/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["supplier-invite"],
    }),
  }),
});

export const { useGetInvitedSuppliersQuery, useInviteSupplierMutation } =
  supplierInviteApi;
